import { ExporterPropertyBase, } from "./SDKExporterPropertyBase";
export class ExporterPropertyDefinitionArray extends ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = "Array";
        this.defaultValues = model.default;
    }
}
